import React, { useContext, FunctionComponent, ComponentClass } from "react";
import { Navigate, useNavigate } from "react-router-dom";

//MUI
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

//Custom Components
import UserContext from "@/components/UserContext/UserContext";
import DialogProvider from "@/ui/DialogContext/DialogProvider";
import DialogContainer from "@/ui/DialogContext/DialogContainer";
import Loader from "@/ui/Loader/Loader";
import { authService } from "@/services/authService";
import { hgssTheme, hpsTheme, regUserTheme } from "@/components/ThemeContext/ThemeProvider";

import { PrivatePageStyle } from "@/@types/common";
import { sifrarnici } from "@/lib/sifrarnici";

const AUTH_TOKEN = "auth_token";

type PrivatePageProps = {
  style?: PrivatePageStyle,
  children: ComponentClass<any, any> | FunctionComponent<any>
}

const PrivatePage = (props: PrivatePageProps) => {
  const userContext = useContext(UserContext);

  const { style } = props;
  const navigate = useNavigate();

  const accessToken = localStorage.getItem(AUTH_TOKEN);
  const hasAccessToken = accessToken !== null && accessToken.length > 0 ? true : false;

  const knowsWhoAmI = userContext !== null && userContext.email !== null && typeof userContext.email === "string" && userContext.email.length > 0 ? true : false;
  const isAuthenticated = hasAccessToken && knowsWhoAmI;

  if (accessToken === sifrarnici.publicToken) {
    navigate("/");
  }

  if (hasAccessToken && !knowsWhoAmI) {
    authService
      .whoAmI()
      .then((user) => {
        if (user === undefined) {
          localStorage.setItem(AUTH_TOKEN, sifrarnici.publicToken);
          navigate("/");
        } else {
          if (userContext !== null) {
            userContext.setUserData(user);
          }
        }
      })
      .catch((err) => {
        console.warn(err);
        localStorage.setItem(AUTH_TOKEN, sifrarnici.publicToken);
        navigate("/");
      })
  }

  const getTheme = (style?: PrivatePageStyle) => {
    switch (style) {
      case 'hgss':
        return hgssTheme;
      case 'hps':
        return hpsTheme;
      case 'reg':
        return regUserTheme;
      default:
        return hgssTheme;
    }
  }

  const theme = getTheme(style);

  if (isAuthenticated) {
    return (
      <MuiThemeProvider
        theme={(outerTheme) => ({
          ...outerTheme,
          palette: {
            ...outerTheme.palette,
            primary: theme.palette.primary,
            secondary: theme.palette.secondary
          }
        })}
      >
        <DialogProvider>
          {React.createElement(props.children)}
          <DialogContainer />
        </DialogProvider>
      </MuiThemeProvider>
    );
  } else if (hasAccessToken && !knowsWhoAmI) {
    return <Loader open={true} />;
  } else {
    return <Navigate to={{ pathname: "/login" }} />;
  }
};

export default PrivatePage;
